export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_OPERATOR = 'ROLE_OPERATOR';
export const ROLE_REPORTS = 'ROLE_REPORTS';

